import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {FormService} from '../../../services/formServices';
import {Area} from '../../../domain/areas';
import {Sede} from '../../../domain/sedes';
import {Categoria} from '../../../domain/categorias';
import {SubCategoria} from '../../../domain/subCategorias';
import {SelectBinding} from '../../../domain/selectBinding';

@Component({
  selector: 'app-select-binding',
  templateUrl: './select-binding.component.html',
  styleUrls: ['./select-binding.component.scss']
})
export class SelectBindingComponent implements OnInit {
  @Input('type') type: string;
  first: any;
  secondary: any;
  selectedValue1: any;
  selectedValue2: any;
  @Output('selected') selected = new EventEmitter<SelectBinding>();
  constructor(private formService: FormService) { }
  ngOnInit() {
      if (this.type === 'zone') {
          this.first = new Area();
          this.secondary = new Sede();
          this.formService.getDataAreas().subscribe(list => this.first.list = list);
          this.formService.getDataSedes(1).subscribe(list => this.secondary.list = list);
      } else if (this.type === 'request') {
          this.first = new Categoria();
          this.secondary = new SubCategoria();
          this.formService.getDataCategoria().subscribe(list => this.first.list = list);
          this.formService.getDataSubCategoria(1).subscribe(list => this.secondary.list = list);
      }
  }
  onChange() {
      if (this.type === 'zone') {
          this.formService.getDataSedes(this.selectedValue1).subscribe(list => this.secondary.list = list);
      } else if (this.type === 'request') {
          this.formService.getDataSubCategoria(this.selectedValue1).subscribe(list => this.secondary.list = list);
      }
  }
  cargarCombos() {
      this.selected.emit(new SelectBinding(this.selectedValue1, this.selectedValue2, this.type));
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/components/selects/select-binding/select-binding.component.ts